import {useQuery} from "@tanstack/react-query";
import {eventsEventIdGet} from "../api/events/eventsEventIdGet.ts";

export const useEvent = (eventId: string) => useQuery({
    queryKey: ['event', eventId],
    queryFn: () => eventsEventIdGet(eventId).then(r => r.payload),
})